import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ResourceMatchesStatus } from '~/types';
import {
  PERIOD_SCALE_ENUM,
  DISPLAY_UNIT_ENUM
} from '~/modules/resourcing/common/enums';
import {
  ResourceMatchItemError,
  ResourceMatchItemNoMatches,
  ResourceMatchItemCalculating,
  ResourceMatchItemMatch
} from './components';
import { RESOURCE_MATCH_ITEM_BUTTONS } from './enums';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0.5, 1),
    minWidth: theme.spacing(21)
  }
}));

export const ResourceMatchItem = ({
  classes: classesOverride,
  matchClasses: matchClassesOverride,
  dataQeId,
  resourceRequest,
  buttonType,
  scale,
  displayUnit,
  setAnchorEl,
  setPopoverResourceRequest,
  project
}) => {
  const classes = useStyles({ classes: classesOverride });
  const resourceMatchesLength = resourceRequest.resourceMatches?.length;
  const dataQeId2 = dataQeId
    ? `${dataQeId}_ResourceMatchItem`
    : 'ResourceMatchItem';

  return (
    <div data-qe-id={dataQeId2} className={classes.root}>
      {resourceRequest.resourceMatchesStatus ===
      ResourceMatchesStatus.Completed ? (
        resourceMatchesLength > 0 ? (
          <ResourceMatchItemMatch
            matchClasses={matchClassesOverride}
            resourceRequest={resourceRequest}
            buttonType={buttonType}
            setAnchorEl={setAnchorEl}
            setPopoverResourceRequest={setPopoverResourceRequest}
            project={project}
          />
        ) : (
          <ResourceMatchItemNoMatches
            dataQeId={dataQeId2}
            resourceRequest={resourceRequest}
            scale={scale}
            displayUnit={displayUnit}
          />
        )
      ) : resourceRequest.resourceMatchesStatus ===
        ResourceMatchesStatus.InProgress ? (
        <ResourceMatchItemCalculating
          dataQeId={dataQeId2}
          resourceRequest={resourceRequest}
        />
      ) : (
        <ResourceMatchItemError
          dataQeId={dataQeId2}
          resourceRequest={resourceRequest}
          scale={scale}
          displayUnit={displayUnit}
        />
      )}
    </div>
  );
};

ResourceMatchItem.propTypes = {
  dataQeId: PropTypes.string,
  classes: PropTypes.object,
  matchClasses: PropTypes.object,
  resourceRequest: PropTypes.object.isRequired,
  buttonType: PropTypes.oneOf(Object.values(RESOURCE_MATCH_ITEM_BUTTONS))
    .isRequired,
  scale: PropTypes.oneOf(Object.values(PERIOD_SCALE_ENUM)),
  displayUnit: PropTypes.oneOf(Object.values(DISPLAY_UNIT_ENUM)),
  setAnchorEl: PropTypes.func.isRequired,
  setPopoverResourceRequest: PropTypes.func.isRequired,
  project: PropTypes.object.isRequired
};

export default ResourceMatchItem;
